import { someHaveAllDealTags } from '@carvana/merch-tile';
import { useMemo } from 'react';
import { Vehicle } from '~/contracts/srp';

// This hook is to determine if the EV tag width should be calculated based off the width of the card.
// This calculation only needs to be done if one of the vehicles has all deal tags. That way the ev tags on all tiles have the same text
export default function useShouldCalculateEvTagWidth(
  inventoryVehicles: Vehicle[],
  similarVehicles: Vehicle[]
) {
  const shouldCalculateEvWidthInventory = useMemo(
    () =>
      inventoryVehicles.length === 0
        ? false
        : someHaveAllDealTags(inventoryVehicles),
    [inventoryVehicles]
  );

  const shouldCalculateEvWidthSimilar = useMemo(
    () =>
      similarVehicles.length === 0
        ? false
        : someHaveAllDealTags(similarVehicles),
    [similarVehicles]
  );

  return {
    shouldCalculateEvWidthInventory,
    shouldCalculateEvWidthSimilar
  };
}
